const state = {
  ...window.__initialAppState.modules.wishlistPage
};

export default state;
